// 側邊欄 星塵紀錄連結
import useUrlStore from '@/store/useUrlStore';
import useModalStore from '@/store/useModalStore';

const pages = [
    { href: '/redemptions', label: '星塵明細' },
    { href: '/redemptions?tab=exchange', label: '兌換紀錄' },
    { href: '/redemptions?tab=lucky_draw', label: '抽獎紀錄' },
];

interface Props {
    uid: string;
}

const AsideLink = ({ uid }: Props) => {
    const { memberUrl } = useUrlStore();
    const { openModal } = useModalStore();

    const onClick = (e: any) => {
        if (!uid) {
            e.preventDefault();
            openModal('LOGIN');
        }
    };

    return (
        <div className="space-y-3">
            {pages.map((page) => {
                const { href, label } = page;
                return (
                    <a
                        key={label + 'aside'}
                        href={memberUrl + href}
                        target="_blank"
                        rel="noreferrer noopener"
                        onClick={onClick}
                        className="py-3.25 text-center block rounded-lg border border-black1 text-black text-btn1
                        trans hover:bg-vPurple hover:text-[#fff]"
                    >
                        {label}
                    </a>
                );
            })}
        </div>
    );
};

export default AsideLink;
